<template>
	<div
		class="c-lightbox"
		:class="{ 'c-lightbox--featured': this.type == 'profiles' }"
	>
		<VueHorizontal ref="carousel" :button="false" @scroll-debounce="onScroll">
			<div
				v-for="item in items"
				class="c-lightbox__content"
				:class="item.device"
				:key="item.index"
			>
				<figure class="o-figure">
					<img
						v-if="item.type != 'video'"
						:src="item.imageUrl"
						class="c-lightbox__image"
						:alt="item.alt"
						loading="lazy"
					/>
					<v-video :video-html="item.code" v-else> </v-video>
					<figcaption v-if="showCaption(item)" class="o-figure__text">
						<span class="o-figure__caption" v-html="item.caption"></span>
						<span class="o-figure__credit" v-html="item.credit"></span>
					</figcaption>
				</figure>

			</div>
		</VueHorizontal>

		<nav class="c-lightbox__nav">
			<button class="c-lightbox__prev" @click="prev($event)" :class="{'is-inactive': !hasPrev}">
				<span class="h-accessibility">Go Back. </span>
				<span class="c-lightbox__icon icon">
					<arrowLeft />
				</span>
			</button>
			<button class="c-lightbox__next" @click="next($event)" :class="{'is-inactive': !hasNext}">
				<span class="h-accessibility">Next Item</span>
				<span class="c-lightbox__icon icon">
					<arrowRight />
				</span>
			</button>
		</nav>

	</div>
</template>

<script>
	import vVideo from "./video.vue";
	import vLoading from "./loading.vue";
	import VueHorizontal from "vue-horizontal";

	import arrowLeft from '/web/static/images/svgs/icon-arrow-left.svg?component';
	import arrowRight from '/web/static/images/svgs/icon-arrow-right.svg?component';

	export default {
		name: "lightbox-carousel",
		components: {
			vLoading,
			vVideo,
			VueHorizontal,
			arrowLeft,
			arrowRight
		},
		data() {
			return {
				hasPrev: false,
				hasNext: true,
			}
		},
		props: {
			items: {
				type: Array,
			},
			index: {
				type: Number,
			},
			type: {
				default: "gallery",
			},
			name: {
				type: String,
			},
			id: {
				type: Number,
			},
		},
		mounted() {
			var self = this;

			console.log(this.items);

			// document.querySelector(".flickity-enabled").focus();
			self.$nextTick(function () {
				// self.$refs.flickity.rerender();

				// window.location.hash =
				// 	self.$props.name + "-" + self.$refs.flickity.selectedIndex();

				window.addEventListener("keydown", function (e) {
					if (e.keyCode == "37") {
						self.prev();
					} else if (e.keyCode == "39") {
						self.next();
					}
				});

				// self.$refs.flickity.on("select", function () {
				// 	window.location.hash =
				// 		self.$props.name + "-" + self.$refs.flickity.selectedIndex();
				// });
			});
		},
		methods: {
			prev(e) {
				this.$refs.carousel.prev(e)
			},
			next(e) {
				this.$refs.carousel.next(e)
			},
			onScroll({hasPrev, hasNext}) {
				this.hasPrev = hasPrev
				this.hasNext = hasNext
			},
			showCaption(item) {
				if(item.caption || item.credit) {
					return true;
				} else {
					return false;
				}
			}
		},
	};
</script>
